import { WithChildren } from '@/_metronic/helpers'
import { BaseRequest } from '@/_metronic/helpers/crud-helper/base-request'
import { createContext, FC, useContext, useState } from 'react'
import { FilterReportTrendAnalysis, initialFilter } from './_models'

type ProductQueryRequestContextProps = {
  state: FilterReportTrendAnalysis
  updateState: (updates: Partial<FilterReportTrendAnalysis>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<ProductQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<FilterReportTrendAnalysis>(initialQueryRequest.state)

  const updateState = (updates: Partial<FilterReportTrendAnalysis>) => {
    const updatedState = {...state, ...updates} as FilterReportTrendAnalysis
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export { QueryRequestProvider, useQueryRequest }

